module.exports = __webpack_public_path__ + "Flag-100.744acc25c2189d9ed8a738899617c158.svg";